import React, { useState, useEffect, useRef } from "react";
import ImageEditor from "../ImageEditor/ImageEditor";
import History from "./History";
import { useImage } from "../../context/ImageContext";
import ImageModal from "../MainCreate/ImageModal";
import { lowQualityToHighQuality } from "../../config/aws";


const MainEdit = ({ editUploadedImages, setEditUploadedImages, brushSize, eraserSize, activeButton, allEditHistory, setAllEditHistory, editPageNumber, setEditPageNumber, selectedGroup, setSelectedGroup, creditsAvailable, setCreditsAvailable, editNumberOfImages, editLoadingCircle, modalImage, setModalImage, containerRef, openSection }) => {

    const { activeTab, setActiveTab } = useImage();

    // useEffect(() => {
    //     if (editUploadedImages !== selectedGroup) {
    //         setSelectedGroup(editUploadedImages);
    //     }
    // }, [editUploadedImages]);



    useEffect(() => {
        const loadHighQualityImages = async () => {

            const updatedImages = [...allEditHistory[0].images];
            for (let i = 0; i < updatedImages.length; i++) {
                // console.log("in MainEdit useEffect allEditHistory changed   fetching high quality images");
                updatedImages[i] = {
                    ...updatedImages[i],
                    src: updatedImages[i].src.includes("lowQuality") ? await lowQualityToHighQuality(updatedImages[i].src) : updatedImages[i].src
                };
            }
            setSelectedGroup(updatedImages);
        };


        if (allEditHistory.length > 0) {
            // loadHighQualityImages();
            setSelectedGroup(allEditHistory[0].images);
        }

    }, [allEditHistory]);

    useEffect(() => {
        // console.log(" selectedGroup changed fetching high quality images");
        selectedGroup.forEach(image => {
            if (image.src.includes("lowQuality")) {
                // console.log("in MainEdit useEffect selectedGroup changed    fetching high quality images");
                lowQualityToHighQuality(image.src).then(highQualityUrl => {
                    image.src = highQualityUrl;
                });
            }
        });
    }, [selectedGroup]);

    const handleDownload = (image) => {
        if (!image) return;
        const link = document.createElement('a');
        link.href = image.src;
        link.download = `image.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Loading state component
    const LoadingState = () => (
        <div className="w-full max-w-6xl space-y-6  p-4 sm:p-6">
            <div className="flex justify-center" style={{ background: '#f8fafc' }}>
                <div className="relative overflow-hidden shadow-lg w-full max-w-5xl">
                    <div
                        className="relative rounded-lg overflow-hidden  flex items-center justify-center"
                        style={{
                            height: 'clamp(300px, 60vh, 500px)',
                            width: '100%',
                            maxWidth: '100%'
                        }}
                    >
                        <div
                            className="w-16 h-16 rounded-full"
                            style={{
                                border: '4px solid #e5e7eb',
                                borderTop: '4px solid #7c3aed',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite'
                            }}
                        ></div>
                    </div>
                </div>
            </div>

            {/* Loading Thumbnail Strip */}
            <div className="flex justify-center">
                <div className="flex space-x-3 sm:space-x-4">
                    {[...Array(editNumberOfImages)].map((_, index) => (
                        <div
                            key={index}
                            className="w-14 h-14 sm:w-16 sm:h-16 rounded-lg overflow-hidden bg-gray-200 shadow-sm flex items-center justify-center"
                        >
                            <div
                                className="w-6 h-6 sm:w-8 sm:h-8 rounded-full"
                                style={{
                                    border: '3px solid #d1d5db',
                                    borderTop: '3px solid #7c3aed',
                                    borderRadius: '50%',
                                    animation: 'spin 1s linear infinite'
                                }}
                            ></div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );

    return (
        <div className="flex flex-col h-full w-full overflow-hidden" ref={containerRef}>
            {/* Main Content Area */}
            <div className="flex-1 flex flex-col items-center justify-center mt-16 min-h-0 w-full max-w-full">
                {editLoadingCircle ? (
                    <LoadingState />
                ) : allEditHistory.length === 0 ? (
                    <div className="flex items-center justify-center h-full w-full max-w-full">
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </div>
                ) : (
                    <ImageEditor
                        selectedGroup={selectedGroup}
                        brushSize={brushSize}
                        eraserSize={eraserSize}
                        activeButton={activeButton}
                        setEditUploadedImages={setEditUploadedImages}
                        creditsAvailable={creditsAvailable}
                        setCreditsAvailable={setCreditsAvailable}
                        openSection={openSection}
                    />
                )}
            </div>

            {/* History Section */}
            <div className="flex-shrink-0">
                <History
                    All_History={allEditHistory}
                    setSelectedGroup={setSelectedGroup}
                    handleDownload={handleDownload}
                    setEditUploadedImages={setEditUploadedImages}
                    setActiveTab={setActiveTab}
                    setModalImage={setModalImage}
                    editPageNumber={editPageNumber}
                    setEditPageNumber={setEditPageNumber}
                    containerRef={containerRef}
                    setAllEditHistory={setAllEditHistory}
                />
            </div>
            {modalImage && (
                <ImageModal
                    image={modalImage}
                    onClose={() => setModalImage(null)}
                />
            )}
        </div>
    );
};

export default MainEdit;
